import type { AdoptionModuleReading } from "../../../api/admin-adoption-api.js";
import type { TenantModuleState } from "../../../api/tenant-config-api.js";

export type ModuleAvailability =
  | "enabled"
  | "disabled"
  | "never-enabled"
  | "unknown";

export interface AdoptionModuleView extends AdoptionModuleReading {
  readonly availability: ModuleAvailability;
}

export function moduleAvailability(
  reading: AdoptionModuleReading,
  modules: readonly TenantModuleState[] | undefined,
): ModuleAvailability {
  if (!modules) return "unknown";
  const module = modules.find(
    (candidate) => candidate.moduleKey === reading.id,
  );
  if (!module) return "unknown";
  if (module.status === "enabled") return "enabled";
  return module.enabledAt === null ? "never-enabled" : "disabled";
}

export function formatCount(value: number | null): string {
  /* locale-number: an activity count, not an instant. */
  return value === null ? "—" : value.toLocaleString();
}
